import { DeleteSessionModal } from "@/components/ai/session/DeleteSessionModal";
import {
    ContextMenuItem,
    ContextMenuRoot,
    ContextMenuTrigger,
    ContextMenuPortal,
    ContextMenuContent,
} from "@/components/flexkit/ContextMenu";
import { RenameSessionModal } from "@/components/ai/session/RenameSessionModal";
import { useState, type FC, type PropsWithChildren } from "react";
import { useSessionActions } from "@/hooks/use-session-actions";
import type { Session } from "./session-model";

type SessionContextMenuProps = {
    session: Session;
} & PropsWithChildren;

export const SessionContextMenu: FC<SessionContextMenuProps> = ({ session, children }) => {
    const [showDeleteSessionModal, setShowDeleteSessionModal] = useState(false);
    const [showRenameSessionModal, setShowRenameSessionModal] = useState(false);
    const { copySessionId } = useSessionActions(session);

    return (
        <>
            <ContextMenuRoot modal={true}>
                <ContextMenuTrigger>{children}</ContextMenuTrigger>
                <ContextMenuPortal>
                    <ContextMenuContent>
                        <ContextMenuItem onClick={copySessionId}>Copy session ID</ContextMenuItem>
                        <ContextMenuItem onClick={() => setShowRenameSessionModal(true)}>
                            Rename session
                        </ContextMenuItem>
                        <ContextMenuItem variant="destructive" onClick={() => setShowDeleteSessionModal(true)}>
                            Delete session
                        </ContextMenuItem>
                    </ContextMenuContent>
                </ContextMenuPortal>
            </ContextMenuRoot>
            <DeleteSessionModal
                session={session}
                open={showDeleteSessionModal}
                onClose={() => setShowDeleteSessionModal(false)}
            />
            <RenameSessionModal
                session={session}
                open={showRenameSessionModal}
                onClose={() => setShowRenameSessionModal(false)}
            />
        </>
    );
};
